<main
  class="chat-host"
  [class.dark-theme]="isDarkTheme"
  [class.chat-host--minimized]="chatMinimized">
  @if (!preloadOnly && widgetMode === 'chat') {
    <app-chat
      [config]="chatConfig"
      [bearerToken]="bearerToken"
      [isCCU]="isCCU"
      [isMobileApp]="isMobileApp"
      [isAndroid]="isAndroid"
      [isDarkTheme]="isDarkTheme"
      [sendIconEnabled]="sendIconEnabled"
      [uploadOptionsEnabled]="uploadOptionsEnabled"
      [buildingEntityList]="buildingEntityList"
      [chatUserInfo]="chatUserInfo"
      (chatEvent)="onChatEvent($event)"
      (clickSupport)="onSupportClick($event)"
      (close)="onChatClose()"
      (minimized)="onChatMinimized()"
      (defaultView)="onDefaultView()"
      (maximized)="onChatMaximized()"
      (expanded)="onChatExpanded()"
      (internalLinkRedirection)="onInternalLinkRedirection($event)"
      (timeoutEvent)="onSessionTimeout($event)"
    ></app-chat>
  }

  @if (!preloadOnly && widgetMode === 'generative-widget' && generativeWidgetReady) {
    <app-generative-widget
      [config]="chatConfig"
      [bearerToken]="bearerToken"
      [buildingEntityList]="buildingEntityList"
      [isAndroid]="isAndroid"
      [sendIconEnabled]="sendIconEnabled"
      (chartGenerated)="onChartGenerated($event)"
      (recommendCharts)="onRecommendCharts($event)"
    ></app-generative-widget>
  }

  @if (!preloadOnly && widgetMode === 'generative-widget-command-layout' && generativeWidgetReady) {
    <app-generative-widget-command-layout
      [config]="chatConfig"
      [bearerToken]="bearerToken"
      [buildingEntityList]="buildingEntityList"
      [isAndroid]="isAndroid"
      [sendIconEnabled]="sendIconEnabled"
      [chatInputPlaceholderText]="chatInputPlaceholderText"
      (chartGenerated)="onChartGenerated($event)"
      (recommendCharts)="onRecommendCharts($event)"
      (variationGenerated)="onVariationGenerated($event)"
    ></app-generative-widget-command-layout>
  }


  <!--Ai quote chat-->
  @if (widgetMode === 'ai-quote-chat') {
    <app-ai-quote-chat
      [config]="chatConfig"
      [bearerToken]="bearerToken"
      [isMobileApp]="isMobileApp"
      [isAndroid]="isAndroid"
      (chatEvent)="onChatEvent($event)"
      (clickSupport)="onSupportClick($event)"
      (close)="onAIQuoteChatClose($event)"
      (minimized)="onChatMinimized()"
      (expanded)="onChatExpanded()"
      (errorMessageHandler)="onErrorMessage($event)"
      (quoteFinalized)="onQuoteFinalized($event)"
    ></app-ai-quote-chat>
  }
</main>
